/* eslint-disable */

import { getDistance } from './helpers';
import { store } from '../stores/mainStore';
import { integration } from '../integration';

var lastTimeSecs = 0;
var numDiceStopped = 0;

export function update(time, delta) {
	const m = window.manager;
	if (!m) {
		console.warn('game running, should be stopping.');
		return;
	}

	const roll3d = (d, i, movePixels) => {
		const distance = getDistance(d.diceSprite.x, d.diceSprite.y, d.lastPosition.x, d.lastPosition.y);
		if (d.frameNum >= 0) {
			if (distance > movePixels) {
				d.lastPosition.x = d.diceSprite.x;
				d.lastPosition.y = d.diceSprite.y;
				if (++d.frameNum >= 9) d.frameNum = 0;
				//d.diceImage.setTexture(store.custom.dice + '_dice3D_sheet', i * 9 + d.frameNum);
				d.diceImage.setTexture('dice3D_sheet', i * 9 + d.frameNum);
			}
		}
	}

	if (m.diceStatus === 'introToCup') {
		m.diceHand.dice.forEach((d, i) => roll3d(d, i,  16 * m.scaleFactor))
		return;
	}

	if (m.diceStatus === 'pokerRush3D') {
		m.diceHand.dice.forEach((d, i) => roll3d(d, i, 32 * m.scaleFactor))
		return;
	}

	if (m.diceStatus === 'launching') {
		if (m.diceHand.diceLaunched < 9) {
			var secs = time / 100;
			if (secs - lastTimeSecs >= 0.15) {
				lastTimeSecs = secs;
				if (m.diceHand.diceLaunched === 0) {
					if (!m.diceReceived) {
						return;
					}
				}
				if (m.diceHand.diceLaunched% 2 === 0) {
					m.playHaptic('haptic_heavyImpact');
				}
				m.diceHand.launchNextDice();
				m.diceHand.diceLaunched++;
			}
		}
	}
	if (m.diceStatus === 'launching') {
		for (let i = 0; i < m.diceHand.diceLaunched; i++) {
			let d = m.diceHand.dice[i];
			if (!d.locked) {
				if(d.frameNum >= 0) {
					roll3d(d, i, 16 * m.scaleFactor);
				} else { 
					d.diceSprite.setVelocity(0, 0);
					d.diceSprite.body.angularVelocity = 0;
				}

				var minVelocity = 1.5; // 4.0;
				if (
					Math.abs(d.diceSprite.body.velocity.x) < minVelocity &&
					Math.abs(d.diceSprite.body.velocity.y) < minVelocity
				) {
					d.lastPosition.x = d.diceSprite.x;
					d.lastPosition.y = d.diceSprite.y;
					d.diceSprite.body.moves = false;
					d.diceSprite.setVelocity(0, 0);
					d.diceSprite.setAngularVelocity(0);
					d.frameNum = -1;
					var face = d.currentFace;
					var num = i * 6 + face;
					//d.diceImage.setTexture(store.custom.dice + '_dice2D_sheet');
					d.diceImage.setTexture('dice2D_sheet');
					d.diceImage.setFrame(num);
					d.diceSprite.setScale(m.dice2DSmallScale);
				} else {
					var collideVelocity = 10;
					if (Math.abs(d.diceSprite.body.velocity.y) < collideVelocity) {
						d.diceSprite.body.collisionFilter.group = 0;
						d.diceSprite.body.collisionFilter.mask = m.diceHand.collisionMask;
					}
				}
			}
		}
		if (m.diceHand.diceLaunched >= 9) {
			numDiceStopped = 0;
			for (let i = 0; i < 9; i++) 
				if (m.diceHand.dice[i].frameNum < 0) 
					numDiceStopped++;
			if (numDiceStopped >= 9) {
				m.diceStatus = 'stopped';
				if(store.activeMatch.matchId !== 'intro')
					m.ui.fadeGoalBanner(true);
				for (let i = 0; i < 9; i++) {
					let d = m.diceHand.dice[i];
					d.diceSprite.body.moves = false;
					d.diceSprite.body.collisionFilter.group = -1;
					d.diceSprite.body.collisionFilter.mask = 0;
					var thisTween = m.scene.tweens.add({
						targets: [d.diceSprite],
						x: d.homePosition.x,
						y: d.homePosition.y,
						scaleX: m.diceBigScale,
						scaleY: m.diceBigScale,
						angle: 0,
						ease: 'Power0',
						delay: 0, //500,
						duration: 420,
						repeat: 0,
						callbackScope: thisTween,
						completeDelay: 0,
						onComplete: function (tween, target, num) {
							if (num === 8) {
								console.log('dice resolved');
								m.gameState.state = 'idle';
								m.diceStatus = 'resolved';
								m.diceHand.resetDicePriority();
						
								if(store.pokerRush) {
									gameSetTimeout(m.diceHand.doPokerRushHand, 500);
								} else {
									//integration.postEvent('dice_roll', `gameplay`, store.activeMatch.handNumber);
						
									//tutorial overlay
									if (store.tutorialMode && store.activeMatch.matchId !== 'intro') {
										m.ui.showTutorialBanner();
						
										if(store.activeMatch.matchId === 'intro2') { //new 2nd FTUE roll
											// hand 1
											// JH = 5,5 roll 1
											// KH = 8,0 
											// XH = 2,2 roll 2
						
											if (store.activeMatch.handNumber === 1) {
												if (store.activeMatch.currentHand.rollNumber === 1) {
													store.tutorialState = 'waitForJHKH';
													store.tutorialPreventRoll = true;
													for (var i = 0; i <= 8; i++)
														if (i != 4 && i != 7)
															m.diceHand.dice[i].darken();
													m.diceHand.dice[4].addSelectPulse();
													m.diceHand.dice[7].addSelectPulse();
													m.ui.createAvaPanel(
														m.config.width / 2,
														m.adjustY(852) * m.ui.avaPanelPos,
														'You rolled 1 pair.\nTap the jacks to hold them.',
														true,
														'tutorial_19'
													);
												}
												if (store.activeMatch.currentHand.rollNumber === 2) {
													store.tutorialState = 'waitFor10H';
													store.tutorialPreventRoll = true;
													for (var i = 0; i <= 8; i++) if (i != 0) m.diceHand.dice[i].darken();
													m.diceHand.dice[4].addFlair('selected', store.settings.theme);
													m.diceHand.dice[4].locked = true;
													m.diceHand.dice[7].addFlair('selected', store.settings.theme);
													m.diceHand.dice[7].locked = true;
													m.diceHand.dice[0].addSelectPulse();
													m.ui.createAvaPanel(
														m.config.width / 2,
														m.adjustY(852) * m.ui.avaPanelPos,
														'Hold your wilds!\nThey are used as the best\ndice to make your hand!',
														true,
														'tutorial_20'
													);
												}
											}
										} else { //normal tutorial
											const boxY = m.adjustY(852) * m.ui.avaPanelPos;
											if (store.activeMatch.handNumber === 1) {
												if (store.activeMatch.currentHand.rollNumber === 1) {
													store.tutorialState = 'waitforjacks';
													store.tutorialPreventRoll = true;
													for (var i = 1; i <= 7; i++) m.diceHand.dice[i].darken();
													m.diceHand.dice[0].addSelectPulse();
													m.diceHand.dice[8].addSelectPulse();
													m.ui.createTutorialBox('skilz_tutorial_1_1', boxY)
												}
												if (store.activeMatch.currentHand.rollNumber === 2) {
													store.tutorialState = 'waitforwild';
													store.tutorialPreventRoll = true;
													for (var i = 2; i <= 7; i++) m.diceHand.dice[i].darken();
													m.diceHand.dice[1].addSelectPulse();
													m.ui.createTutorialBox('skilz_tutorial_1_2', boxY)
												}
											}
						
											if (store.activeMatch.handNumber === 2) {
												if (store.activeMatch.currentHand.rollNumber === 1) {
													store.tutorialState = 'waitforking';
													store.tutorialPreventRoll = true;
													for (var i = 0; i <= 8; i++) if (i != 3 && i != 5) m.diceHand.dice[i].darken();
													m.diceHand.dice[3].addSelectPulse();
													m.diceHand.dice[5].addSelectPulse();
													m.ui.showSelectDiceMsg();
													m.ui.createTutorialBox('skilz_tutorial_2_1', boxY)
												}
												if (store.activeMatch.currentHand.rollNumber === 2) {
													store.tutorialState = 'waitforking2';
													store.tutorialPreventRoll = true;
													for (var i = 0; i <= 8; i++)
														if (i != 1 && i != 3 && i != 4 && i != 5) m.diceHand.dice[i].darken();
													m.diceHand.dice[3].locked = true;
													m.diceHand.dice[5].locked = true;
													m.diceHand.dice[1].addSelectPulseYellowDot();
													m.diceHand.dice[4].addSelectPulseYellowDot();
													m.ui.showSelectDiceMsg();
													m.ui.createTutorialBox('skilz_tutorial_2_2', boxY)
												}
											}
											if (store.activeMatch.handNumber === 3) {
												if (store.activeMatch.currentHand.rollNumber === 1) {
													store.tutorialState = 'waitforstraight';
													store.tutorialPreventRoll = true;
													for (var i = 0; i <= 8; i++)
														if (i != 3 && i != 2 && i != 6 && i != 7 && i != 0) m.diceHand.dice[i].darken();
													m.diceHand.dice[2].addSelectPulse();
													m.diceHand.dice[3].addSelectPulse();
													m.diceHand.dice[7].addSelectPulse();
													m.diceHand.dice[6].addSelectPulse();
													m.diceHand.dice[0].addSelectPulse();
													m.ui.showSelectDiceMsg();
													m.ui.createTutorialBox('skilz_tutorial_3_1', boxY)
												}
											}
										}
									}
									if (store.tutorialMode) { 
										if(store.activeMatch.matchId === 'intro') {
											m.playAudio('epic_win');
											m.ui.showBigWinBanner();
											gameSetTimeout(m.ui.endOfShortTutorial, 1000);
											return;
										}
										if(store.activeMatch.matchId === 'intro2' && store.activeMatch.currentHand.rollNumber === 3) {
											m.ui.fadeGoalBanner(0);
											m.playAudio('epic_win');
											m.ui.showBigWinBanner();
											gameSetTimeout(m.ui.endOfShortTutorial, 1000);
											return;
										}
									}

									m.allDiceResolved();
								}
							}
						},
						onCompleteParams: [d.diceNum],
						onCompleteScope: thisTween,
					});
				}
			}
		}
	}
}
